import React from 'react'
import ReactApexChart from 'react-apexcharts'

export function DashboardStackedBar({ data, lineNames = [], colors, height = 800, max, min, stacked = true, chartId }) {
  const dashboardOptions = {
    series: data,
    options: {
      chart: {
        id: chartId,
        type: 'bar',
        height: '100%',
        stacked: stacked,
        stackType: stacked ? '100%' : 'normal'
      },
      colors: colors || ['#F7685B', '#FFB946', '#F2E14C', '#2ED47A', '#109CF1', '#885AF8'],
      plotOptions: {
        bar: {
          horizontal: true,
        },
      },
      stroke: {
        width: 1,
        colors: ['#fff']
      },
      xaxis: {
        type: 'category',
        categories: lineNames,
        max,
        min,
        labels: {
          show: false
        }
      },
      fill: {
        opacity: 1
      },
      legend: {
        position: 'top',
        horizontalAlign: 'left',
        offsetX: 40
      }
    },
  };

  return (
    <ReactApexChart options={dashboardOptions.options} series={dashboardOptions.series} type="bar" height={height} />
  )
}



// WEBPACK FOOTER //
// ./src/component/Dashboard/DashboardStackedBar.js